import React, { useEffect, useState } from "react";
import BoxPayGrid from "../../BoxPayGrid";
import { useAuth } from "../../../context/API_Client";
import NameField from "./nameField";
import { apiCredsSchema } from "./apiCredsSchema";
import { convertIsoToGivenDateFormat, convertIsoToGivenTimeZone } from "../../utils/utils";
import { customToast } from "../../../reusableComponents/customToaster/customToast";
import LoadingLogoPage from "../../loadingPage/loadingPage";

function ApiCreds(operationPermissions) {
  const {
    getApiCredentials,
    getApiCredentialsName,
    merchantSettings,
    getAllModalData,
  } = useAuth();
  const [gridData, setGridData] = useState([]);
  const [selectedBusinessUnitData, setSelectedBusinessUnitData] = useState([]);
  const [error, setError] = useState([]);
  const [name, setName] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [loading, setLoading] = useState(true);
  const [businessUnitData, setBusinessUnitData] = useState(null);

  const handleBusinessUnitForPayload = (data) => {
    setSelectedBusinessUnitData(data);
  };
  useEffect(() => {
    merchantSettings(
      function (data) {
        setTimeZone(data?.timeZone);
      },
      function (errorMsg) {}
    );
    getAllModalData(
      function (data) {
        setBusinessUnitData(data?.legalEntities);
      },
      function (errorMsg) {}
    );
  }, []);

  useEffect(() => {
    if (timeZone) {
      getApiCredentials(
        function (data) {
          const filteredData = data.map((rawData) => {
            const epochValue = rawData.addedDTime;
            const outputDatetimeStr = convertIsoToGivenDateFormat(
              epochValue,
              timeZone
            );
            rawData["addedDTime"] = outputDatetimeStr;
            const businessUnitNames = rawData?.businessUnits?.map(
              (unitCode) => {
                return (
                  businessUnitData.find(
                    (legalEntity) => legalEntity?.code === unitCode
                  )?.name || unitCode
                );
              }
            );
            rawData["businessUnitsNames"] = businessUnitNames;
            return rawData;
          });
          setGridData(filteredData);
          setLoading(false);
        },
        function (errorMsg) {
          setError(errorMsg);
          setLoading(false);
        }
      );
    }
  }, [timeZone]);

  useEffect(() => {
    if (name) {
      const payload = { name, businessUnits: selectedBusinessUnitData };
      getApiCredentialsName(
        name,
        payload,
        (data) => {
          const epochValue = data.addedDTime;
          const outputDatetimeStr = convertIsoToGivenDateFormat(
            epochValue,
            timeZone
          );
          
          data["addedDTime"] = outputDatetimeStr;
          setGridData((prevData) => [...prevData, data]);
          customToast("success", "high", `API Key succesfully generated!`);
        },
        (errorMsg) => {
          setError(errorMsg);
          customToast("error", "high", errorMsg);
        }
      );
    }
  }, [name]);

  return (
    <>
      {loading ? (
        <div className="content-wrapper">
          <section
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "white",
            }}
          >
            <LoadingLogoPage />
          </section>
        </div>
      ) : (
        <div className="content-wrapper" style={{ backgroundColor: "white" }}>
          <section className="content">
            <div
              style={{
                width: "100%",
              }}
            >
              <NameField
                text={name}
                setText={setName}
                expandable={true}
                operationPermissions={operationPermissions}
                handleBusinessUnitForPayload={handleBusinessUnitForPayload}
              />
              <div style={{ display: "flex", marginTop: "32px" }}>
                <BoxPayGrid
                  schema={apiCredsSchema}
                  data={gridData}
                  showCustomizeButton={false}
                  operationPermissions={operationPermissions}
                />
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
}

export default ApiCreds;
